module.exports = __webpack_public_path__ + "img/login_background.97b75f0a.png";